export default __webpack_public_path__ + "static/media/tn.b0954937.svg";